import Api from '../abstract';

export let GET_LIST_DATA_SHARE = (params, successCallback, errorCallback) => {
    let url = `/user/data/${params.payload.shareId}?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let DELETE_DATA_SHARE = (params, successCallback, errorCallback) => {
    let url = `/user/data/${params.payload.shareId}/${params.payload.recordId}/delete`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};

export let CREATE_DATA_SHARE = (params, successCallback, errorCallback) => {
    let url = `/user/data/${params.payload.shareId}/create`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let UPDATE_DATA_SHARE = (params, successCallback, errorCallback) => {
    let url = `/user/data/${params.payload.shareId}/update/record`;
    let data = params.payload.data;
    return Api.put(url, data).then(successCallback).catch(errorCallback);
};

export let UPDATE_MULTIPLE_DATA_SHARE = (params, successCallback, errorCallback) => {
    let url = `/user/data/${params.payload.shareId}/update/records`;
    let data = params.payload.data;
    return Api.put(url, data).then(successCallback).catch(errorCallback);
};

export let GET_DETAIL_DATA_SHARE = (params, successCallback, errorCallback) => {
    let url = `/user/data/${params.payload.shareId}/${params.payload.recordId}/detail`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_LIST_FIELDS_RECORD = (params, successCallback, errorCallback) => {
    let url = `/user/data/listField/${params.payload.appId}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_ALL_ROLES_USER = (params, successCallback, errorCallback) => {
    let url = `/user/links/share`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_ALL_GROUP_USER = (params, successCallback, errorCallback) => {
    let url = `/user/data/getGroupUser/${params.payload.shareId}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_DATA_APP_BY_ID = (params, successCallback, errorCallback) => {
    let url = `/user/data/getViewAll/${params.payload.shareId}/${params.payload.appId}/${params.payload.relatedField}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};
